module.exports = __webpack_public_path__ + "img/tree-09-b-trunk.f6ffefa5.png";